import classNames from 'classnames';
import React from 'react';
import { Button, ButtonProps } from '../Button';
import styles from './StyledDialog.module.scss';

export type StyledDialogButtonProps = ButtonProps & {
    label?: string;
    alignLeft?: boolean;
    compact?: boolean;
};

export function StyledDialogButton(props: StyledDialogButtonProps) {
    const { alignLeft, compact, ...otherProps } = props;
    const classes = classNames(styles.button, {
        [styles.alignLeft]: alignLeft,
        [styles.compact]: compact
    });

    return (
        <Button {...otherProps} className={classes} width={112} subtleShadeOnHover>
            {props.children}
            {props.label}
        </Button>
    );
}
